import React, { useState } from 'react';

const ImageWithFallback = ({ src, alt, fallback, className, ...props }) => {
  const [hasError, setHasError] = useState(false);

  if (!src || hasError) {
    // Return fallback component if provided, otherwise return a simple placeholder div
    if (fallback) {
      return fallback;
    }
    return (
      <div
        className={`bg-canvas-primary text-white flex items-center justify-center text-sm font-semibold ${className}`}
        title={alt}
      >
        {/* Initials or icon placeholder */}
        {alt ? alt.charAt(0).toUpperCase() : '?'}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
      {...props}
    />
  );
};

export default ImageWithFallback;
